import { all } from "redux-saga/effects";
import AuthSaga from "./auth";

function* rootSaga() {
    yield all([AuthSaga()]);
}

export default rootSaga;
